import { SAGA_ACTIONS } from "src/_config";
import { useApiCall } from "../common/appApiCallHook";

export function useEmployerJobApi() {
  const callApi = useApiCall();

  const getEmployerJobs = (employerId: string, params = {}, onSuccess: Function, onError: Function) => {
    const payload = {
      employerId,
      params,
    };
    callApi(SAGA_ACTIONS.JOB.GET_EMPLOYER_JOBS, payload, onSuccess, onError, true);
  };

  const updateJobStatus = (jobId: string, data: any, onSuccess: Function, onError: Function) => {
    const payload = {
      jobId,
      data,
    };
    callApi(SAGA_ACTIONS.JOB.UPDATE_JOB_STATUS, payload, onSuccess, onError, true);
  };

  const cloneJob = (jobId: string, data: any, onSuccess: Function, onError: Function) => {
    const payload = {
      jobId,
      data,
    };
    callApi(SAGA_ACTIONS.JOB.CLONE_JOB, payload, onSuccess, onError, true);
  };

  const getJobCandidates = (jobId: string, params = {}, onSuccess: Function, onError: Function) => {
    const payload = {
      jobId,
      params,
    };
    callApi(SAGA_ACTIONS.JOB.GET_JOB_CANDIDATES, payload, onSuccess, onError, true);
  };

  const getCandidateDetails = (jobId: string, candidateId: string, onSuccess: Function, onError: Function) => {
    const payload = {
      jobId,
      candidateId,
    };
    callApi(SAGA_ACTIONS.JOB.GET_CANDIDATE_DETAILS, payload, onSuccess, onError, true);
  };

  const getScreening = (jobId: string, limit = 10, offset = 0, params = {}, onSuccess: Function, onError: Function) => {
    const payload = {
      jobId,
      limit,
      offset,
      ...params, // Include additional parameters like search
    };
    callApi(SAGA_ACTIONS.JOB.GET_SCREENING, payload, onSuccess, onError, false);
  };

  const bulkResumeUpload = (jobEmpId: string, files: File[], onSuccess: Function, onError: Function) => {
    const payload = {
      jobEmpId,
      files,
    };
    callApi(SAGA_ACTIONS.JOB.BULK_RESUME_UPLOAD, payload, onSuccess, onError, true);
  };

  const getJobStatusCounts = (jobIds: string[] = [], onSuccess: Function, onError: Function) => {
    const payload = {
      jobIds,
    };
    callApi(SAGA_ACTIONS.JOB.GET_JOB_STATUS_COUNTS, payload, onSuccess, onError, true);
  };

  const getAppliedJobsLastSevenDays = (
    params: { job_ids?: string[]; from_date?: string; to_date?: string; matching_percentage?: number },
    onSuccess: Function,
    onError: Function,
  ) => {
    callApi(SAGA_ACTIONS.JOB.GET_APPLIED_JOBS_LAST_SEVEN_DAYS, params, onSuccess, onError, true);
  };

  const getJobAllStatusCounts = (
    params: { job_ids?: string[]; from_date?: string; to_date?: string; matching_percentage?: number },
    onSuccess: Function,
    onError: Function,
  ) => {
    callApi(SAGA_ACTIONS.JOB.GET_JOB_ALL_STATUS_COUNTS, params, onSuccess, onError, true);
  };

  const getJobseekerDetailsById = (jobseekerId: number, isBulkCV: boolean, onSuccess: Function, onError: Function) => {
    const payload = {
      jobseekerId,
      isBulkCV,
    };
    callApi(SAGA_ACTIONS.JOB.GET_JOBSEEKER_DETAILS_BY_ID, payload, onSuccess, onError, true);
  };

  const getJobDetails = (jobId: string, onSuccess: Function, onError: Function) => {
    const payload = {
      jobId,
    };
    callApi(SAGA_ACTIONS.JOB.GET_JOB_DETAILS, payload, onSuccess, onError, true);
  };

  const triggerMatching = (jobEmpId: string, params = {}, onSuccess: Function, onError: Function) => {
    const payload = {
      jobEmpId,
      ...params,
    };
    callApi(SAGA_ACTIONS.JOB.TRIGGER_MATCHING, payload, onSuccess, onError, true);
  };

  const deleteJob = (jobId: string, onSuccess: Function, onError: Function) => {
    const payload = { jobId };
    callApi(SAGA_ACTIONS.JOB.DELETE_JOB, payload, onSuccess, onError, true);
  };

  const userJobRefreshSet = (data: { user_id: number; job_emp_id: string }, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.JOB.USER_JOB_REFRESH_SET, data, onSuccess, onError, true);
  };

  const userJobRefreshRemove = (
    data: { user_id: number; job_emp_id: string },
    onSuccess: Function,
    onError: Function,
  ) => {
    callApi(SAGA_ACTIONS.JOB.USER_JOB_REFRESH_REMOVE, data, onSuccess, onError, true);
  };

  const userJobRefreshGet = (
    params: { user_id: number; job_emp_id: string },
    onSuccess: Function,
    onError: Function,
  ) => {
    callApi(SAGA_ACTIONS.JOB.USER_JOB_REFRESH_GET, params, onSuccess, onError, true);
  };

  return {
    callGetEmployerJobs: getEmployerJobs,
    callUpdateJobStatus: updateJobStatus,
    callCloneJob: cloneJob,
    callGetJobCandidates: getJobCandidates,
    callGetCandidateDetails: getCandidateDetails,
    callGetScreening: getScreening,
    callBulkResumeUpload: bulkResumeUpload,
    callGetJobStatusCounts: getJobStatusCounts,
    callGetAppliedJobsLastSevenDays: getAppliedJobsLastSevenDays,
    callGetJobAllStatusCounts: getJobAllStatusCounts,
    callGetJobseekerDetailsById: getJobseekerDetailsById,
    callGetJobDetails: getJobDetails,
    callTriggerMatching: triggerMatching,
    callUserJobRefreshSet: userJobRefreshSet,
    callUserJobRefreshRemove: userJobRefreshRemove,
    callUserJobRefreshGet: userJobRefreshGet,
    callDeleteJob: deleteJob,
  };
}
